import { Observable } from 'rxjs';
import { UserInfo } from '../../models/user-info/user-info.model';

export abstract class AbstractUserInfoService {
    abstract getUserInfo: () => Observable<UserInfo | undefined>;
}
